const Config = require('~config/default.env').default;
import axios from 'axios';

const countRequest = (payload) => {
  return axios.get(`${Config.MS_ORDER_API_URL}/user/me/orders/count`, payload);
};

const readRequest = (payload) => {
  return axios.get(`${Config.MS_ORDER_API_URL}/user/me/orders`, payload);
};

const stateRequest = () => {
  return axios.get(`${Config.MS_ORDER_API_URL}/order-state`, {
    params: {
      field: 'name,color,_id',
    },
  });
};

const createRequest = (payload) => {
  return axios.post(`${Config.MS_ORDER_API_URL}/users/me/orders`, payload);
};

const repayCC = (payload) => {
  return axios.post(`${Config.MS_ORDER_API_URL}/order/repaycc`, payload);
};

const paymentConfirmRequest = (payload) => {
  return axios.post(
    `${Config.MS_PAYMENT_API_URL}/payment-confirms/${payload._id}`,
    payload.payload,
  );
};

const bankAccountRequest = (payload) => {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/bank-accounts`, payload);
};

const trackRequest = (payload) => {
  return axios.get(`${Config.MS_ORDER_API_URL}/order/${payload._id}/track`, {
    ...(payload?.is_send_as_gift && {
      params: {
        filter: {
          is_send_as_gift: payload?.is_send_as_gift,
        },
      },
    }),
  });
};

const packageReceivedRequest = (payload) => {
  return axios.put(
    `${Config.MS_ORDER_API_URL}/order/${payload._id}/status/${payload.delivered_id}`,
  );
};

const retryRequest = (payload) => {
  return axios.put(`${Config.MS_ORDER_API_URL}/order/${payload}/retry`);
};

const retryByPhoneNumberRequest = (payload) => {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/payments`, payload);
};

const getRecentlyBought = (payload) => {
  return axios.get(
    `${Config.MS_ORDER_API_URL}/users/me/recently-bought`,
    payload,
  );
};

const editPaymentOrder = (payload) => {
  return axios.post(
    `${Config.MS_ORDER_API_URL}/order/${payload.id}/edit-payment`,
    payload.data,
  );
};

const placePaymentOrder = (payload) => {
  return axios.post(`${Config.MS_ORDER_API_URL}/users/me/orders`, payload);
};

const getOrdersDetails = (payload) => {
  return axios.get(`${Config.MS_ORDER_API_URL}/order/${payload._id}`, {
    params: {
      fields:
        'reference_code shipping order_source state.name state_histories.from_status.name state_histories.to_status.name total_paid total_shipping total_discount total_quantity created_at updated_at payment_method order_source total_saving voucher_code products free_products delivered_at user cart_id store valid price total_paid_app price_after_discount price_after_discount_app price_app total_discount_app package_no mask_reference_code order_type total_redeem_point package_validate_at shipped_at documents soco_state queue_number is_beauty_xchange is_payment_method_change voucher_applied, partial_refund_status_histories, return_histories, is_partial_refund, refund_amount, refund_point, total_refund_quantity, refund_state, refund_detail, total_weight, total_redeem_point_discount, earned_point, last_status_order_track, voucher_applied_gwp_with_code',
    },
  });
};

const getPickUpStoreOrderDetail = (payload) => {
  return axios.get(
    `${Config.MS_ORDER_API_URL}/user/me/orders/self-pick-up`,
    payload,
  );
};

const cancelRequest = (payload) => {
  return axios.put(
    `${Config.MS_ORDER_API_URL}/order/${payload.id}/cancelled`,
    payload.data,
  );
};

const cancellationReasonsRequest = () => {
  return axios.get(`${Config.MS_ORDER_API_URL}/cancellation-reasons`, {
    params: {
      sort: 'position',
      filter: {
        is_enabled_lilla: true,
        is_display: true,
      },
    },
  });
};

export const Orders = {
  countRequest,
  readRequest,
  stateRequest,
  createRequest,
  bankAccountRequest,
  paymentConfirmRequest,
  trackRequest,
  packageReceivedRequest,
  retryRequest,
  retryByPhoneNumberRequest,
  getRecentlyBought,
  repayCC,
  editPaymentOrder,
  placePaymentOrder,
  getOrdersDetails,
  getPickUpStoreOrderDetail,
  cancelRequest,
  cancellationReasonsRequest,
};
